import React from 'react';
import { Frown, Smile } from 'lucide-react';
import ThinkingIndicator from '../ThinkingIndicator';
import { useTranslate } from '../../lib/i18n';
import ResearchConsentCard from './ResearchConsentCard';

interface Props {
  content: string;
  isExpanded: boolean;
  onToggle: () => void;
  onResponse: (consentGiven: boolean) => void;
  hasResponded: boolean;
  currentConsent: boolean | null;
}

/**
 * Component for displaying research consent messages with consent collection functionality
 */
const ResearchConsentMessage = ({
  content,
  isExpanded,
  onToggle,
  onResponse,
  hasResponded,
  currentConsent,
}: Props) => {
  const t = useTranslate();

  return (
    <div className="relative my-4">
      <div className="flex animate-slide-up items-start">
        <div className="shrink-0">
          <div className="h-8 w-8" />
        </div>
        <div className="mx-2 grow space-y-1">
          <div className="space-y-2 text-sm">
            {content === t('common.labels.writing') ? (
              <ThinkingIndicator />
            ) : (
              <ResearchConsentCard
                content={content}
                isExpanded={isExpanded}
                onToggle={onToggle}
                onResponse={onResponse}
                hasResponded={hasResponded}
                currentConsent={currentConsent}
              />
            )}
          </div>
        </div>
        {/* Invisible spacer to match exact feedback button dimensions */}
        <div className="shrink-0">
          <button
            className="flex w-auto flex-col items-center justify-center gap-0.5 rounded-full border px-1 py-1 opacity-0 pointer-events-none"
            disabled
          >
            <Smile className="scale-10 text-foreground" size={20} />
            <Frown className="scale-10 text-foreground" size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResearchConsentMessage;
